import React from 'react';
import './CTA.scss';
import Button from './Button';
import Hyperlink from '../Hyperlink/Hyperlink';

function CTA({ origin }) {
  const hyperlinkData = {
    data1: {
      copy: 'and on Earth',
      href: 'https://www.morganstanley.com/articles/investing-with-impact?cid=mg-cap-cnncreat-12576'
    },
    data2: {
      copy: 'Find out how you can begin investing in space today',
      href: 'https://us.etrade.com/knowledge/thematic-investing/space?cid=mg-cap-cnncreat-12579'
    }
  };

  return (
    <div className="cta">
      <div className="cta__contents">
        <div className="cta__contents__line" />
        <div className="commonCopy__contents">
          {origin === 'intro' ? (
            <p className="commonCopy__contents__paragraphs">
              Morgan Stanley believes that everyone should have an opportunity to participate in the
              $1 trillion space economy and they are committed to building solutions that make life
              in the stars —{' '}
              <span className="commonCopy__contents__paragraphs--link">
                <Hyperlink hyperlinkData={hyperlinkData.data1} />
              </span>{' '}
              — more equitable and accessible.{' '}
              <span className="commonCopy__contents__paragraphs--link">
                <Hyperlink hyperlinkData={hyperlinkData.data2} />
              </span>
              .
            </p>
          ) : (
            <p className="commonCopy__contents__paragraphs">
              The Access I will be on display in Times Square on Wednesday, October 26. Experience
              space from the center of the Universe and imagine yourself as part of the next
              generation of astronauts.
            </p>
          )}
        </div>

        <Button origin={origin} />
      </div>
    </div>
  );
}

export default CTA;
